import classnames from 'classnames'

import AnimateIntoView from '~/components/atoms/AnimateIntoView/AnimateIntoView'
import type { ArtworkCardProps } from '~/components/atoms/ArtworkCard/ArtworkCard'
import ArtworkCard from '~/components/atoms/ArtworkCard/ArtworkCard'
import Container from '~/components/atoms/Container/Container'
import { Col, Grid, Row } from '~/components/atoms/Grid'
import Spacer, { SpacerSizes } from '~/components/atoms/Spacer/Spacer'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import VerticalPadder from '~/components/atoms/VerticalPadder/VerticalPadder'

import styles from './CuratedArtworksList.module.css'

export interface CuratedArtworksListProps {
  artworksList: ArtworkCardProps[]
  title?: string
  summary?: string
}

export default function CuratedArtworksList({
  title,
  artworksList,
  summary,
}: CuratedArtworksListProps) {
  return (
    <div>
      {title && (
        <Container>
          <div className={styles.titleContainer}>
            <div className={classnames(styles.title)}>
              <Text Tag="h2" size={TextSizes.primaryTitleMed}>
                <span dangerouslySetInnerHTML={{ __html: title }} />
              </Text>
            </div>
          </div>
          {summary && (
            <Text className={styles.summary} Tag="p" size={TextSizes.bodyMed}>
              {summary}
            </Text>
          )}
          <div className={styles.keyLine}></div>
        </Container>
      )}
      <div className={classnames(styles.artworksContainer)}>
        <Container>
          <VerticalPadder noPaddingTop={true}>
            {artworksList && artworksList.length > 0 && (
              <>
                <Grid>
                  <Row>
                    {artworksList.map((item: ArtworkCardProps, i: number) => {
                      return (
                        <Col
                          variant="col-1/2--sm col-1/3--md col-1/4--hg"
                          key={`artworkcard-${item.title}${i}`}
                        >
                          <AnimateIntoView>
                            <ArtworkCard
                              {...item}
                              itemIndex={i + 1}
                              noArtistLink={true}
                            />
                            <Spacer size={SpacerSizes.lg} />
                          </AnimateIntoView>
                        </Col>
                      )
                    })}
                  </Row>
                </Grid>
              </>
            )}
          </VerticalPadder>
        </Container>
      </div>
    </div>
  )
}
